export default "__VITE_ASSET__D6Az0oHf__"